import maplibregl from 'maplibre-gl';
import { MAP_CONFIG, BASEMAP_URL, BASEMAP_ATTRIBUTION } from '../config/map.js';

export function createMap() {
  const map = new maplibregl.Map({
    container: 'map',
    style: {
      version: 8,
      sources: {
        'pdok-basemap': {
          type: 'raster',
          tiles: [BASEMAP_URL],
          tileSize: 256,
          attribution: BASEMAP_ATTRIBUTION,
        },
      },
      layers: [
        {
          id: 'basemap',
          type: 'raster',
          source: 'pdok-basemap',
          minzoom: 0,
          maxzoom: 19,
        },
      ],
    },
    center: MAP_CONFIG.center,
    zoom: MAP_CONFIG.zoom,
    pitch: MAP_CONFIG.pitch,
    minZoom: MAP_CONFIG.minZoom,
    maxZoom: MAP_CONFIG.maxZoom,
    maxBounds: MAP_CONFIG.maxBounds,
  });

  map.addControl(new maplibregl.NavigationControl(), 'bottom-right');
  map.addControl(new maplibregl.ScaleControl({ unit: 'metric' }), 'bottom-left');

  return map;
}
